(function () {
  'use strict';
  if (document.body.dataset.cloudWishlist !== 'true') return;
  const M = window.Motion;
  if (!M) return;
  let sdk, items = [], ready = false, refreshTask, busy = false;
  function localItems() {
    try { return M.C.normalizeWishlist(JSON.parse(localStorage.getItem('motion-wishlist') || '[]')); }
    catch { return []; }
  }
  function handleOf(item) {
    if (item.ProductHandle) return String(item.ProductHandle);
    try { return decodeURIComponent(new URL(item.ProductLink, location.origin).pathname.split('/products/')[1]?.split('/')[0] || ''); }
    catch { return ''; }
  }
  function handles() { return M.C.normalizeWishlist([...items.map(handleOf).filter(Boolean), ...localItems()]); }
  function status(key) {
    document.querySelectorAll('[data-wishlist-sync-status]').forEach(node => { node.textContent = M.t(key); });
  }
  function render() {
    M.syncWishlist();
    M.renderWishlist();
    document.querySelectorAll('[data-wishlist-migrate]').forEach(button => { button.hidden = !localItems().length; button.disabled = busy || !ready; });
    document.querySelectorAll('[data-wishlist-retry]').forEach(button => { button.hidden = ready; });
  }
  function setBusy(value) {
    busy = value;
    document.querySelectorAll('[data-wish],[data-wishlist-migrate]').forEach(button => { button.disabled = value; button.setAttribute('aria-busy', String(value)); });
  }
  function readItems(result) {
    if (Array.isArray(result)) return result;
    if (result?.ok === false) throw new Error('Wishlist request failed');
    if (Array.isArray(result?.Items)) return result.Items;
    if (Array.isArray(result?.items)) return result.items;
    throw new Error('Invalid wishlist response');
  }
  async function refresh() {
    if (refreshTask) return refreshTask;
    refreshTask = (async () => {
      if (!sdk) throw new Error('Wishlist not ready');
      const hash = await sdk.GetWishListHash(false);
      items = hash ? readItems(await sdk.GetWishListItemsFromServer()) : [];
      ready = true;
      status(localItems().length ? 'wishlistLocalPending' : 'wishlistCloudReady');
      render();
    })().catch(error => { ready = false; status('wishlistSyncError'); render(); throw error; }).finally(() => { refreshTask = null; });
    return refreshTask;
  }
  async function descriptor(handle, trigger) {
    const product = await M.getProduct(handle);
    const form = trigger?.closest('[data-product-page]')?.querySelector('[data-product-form]');
    const selected = form?.querySelector('[name="id"]')?.value || trigger?.closest('[data-card]')?.dataset.variantId;
    const variant = product.variants.find(v => String(v.id) === String(selected)) || product.variants.find(v => v.available) || product.variants[0];
    if (!variant) throw new Error('Product unavailable');
    return { WishlistHash: await sdk.GetWishListHash(true), ProductId: String(product.id), ProductVariantId: String(variant.id), ProductTitle: product.title, ProductPrice: variant.price / 100, ProductLink: new URL(product.url, location.origin).href, ProductImage: variant.featured_image?.src || product.featured_image };
  }
  function requireSuccess(result) { if (result?.ok !== true) throw new Error('Wishlist write failed'); }
  function removeLocal(handle) { localStorage.setItem('motion-wishlist', JSON.stringify(localItems().filter(value => value !== handle))); }
  async function toggle(handle, trigger) {
    if (busy) return false;
    if (!sdk || !ready) { M.notice(M.t('wishlistSyncError')); refresh().catch(() => {}); return false; }
    setBusy(true);
    try {
      await refresh();
      const existing = items.filter(item => handleOf(item) === handle);
      const removing = existing.length > 0 || localItems().includes(handle);
      if (removing) {
        const hash = await sdk.GetWishListHash(false);
        for (const item of existing) requireSuccess(await sdk.DeleteWishListItem({ WishlistHash: hash, ProductVariantId: String(item.ProductVariantId) }));
        removeLocal(handle);
      } else {
        await sdk.GetWishListHash(true);
        requireSuccess(await sdk.AddWishListItem(await descriptor(handle, trigger)));
      }
      await refresh();
      if (handles().includes(handle) === removing) throw new Error('Wishlist update not confirmed');
      M.notice(M.t(removing ? 'removed' : 'saved'));
      return true;
    } catch (error) {
      status('wishlistSyncError'); M.notice(M.t('wishlistSyncError')); return false;
    } finally { setBusy(false); render(); }
  }
  async function migrate() {
    if (busy || !ready) return;
    setBusy(true);
    try {
      await refresh();
      await sdk.GetWishListHash(true);
      for (const handle of localItems()) {
        if (!items.some(item => handleOf(item) === handle)) requireSuccess(await sdk.AddWishListItem(await descriptor(handle)));
        await refresh();
        if (!items.some(item => handleOf(item) === handle)) throw new Error('Migration not confirmed');
        removeLocal(handle);
      }
      status('wishlistCloudReady');
    } catch (error) { status('wishlistSyncError'); }
    finally { setBusy(false); render(); }
  }
  async function start() {
    sdk = window.WishListHero_SDK;
    if (!sdk) return;
    await refresh().catch(() => {});
  }
  window.MotionWishlist = { handles, toggle, refresh };
  document.addEventListener('wishlist-hero-wishlist-sdk-ready', start);
  document.addEventListener('wishlist-hero-wishlist-updated', () => { if (!busy) refresh().catch(() => {}); });
  document.addEventListener('wishlist-hero-wishlist-items-from-server', () => {
    if (refreshTask || busy || !sdk) return;
    try { items = readItems(sdk.GetWishListItems()); ready = true; render(); } catch { status('wishlistSyncError'); }
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-wishlist-migrate]')) migrate();
    if (event.target.closest('[data-wishlist-retry]')) start();
  });
  window.addEventListener('pageshow', () => { if (sdk && !busy) refresh().catch(() => {}); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && sdk && !busy) refresh().catch(() => {}); });
  status('wishlistSyncLoading');
  render();
  start();
})();
